import styled from 'styled-components';
import { darken, lighten } from 'utils';
import Typography from 'components/atoms/Typography';

export const Root = styled.div`
  background: ${({ theme }) =>
    theme.isDarkMode ? lighten(theme.palette.background, 0.09) : 'transparent'};
  border-radius: ${({ theme }) => theme.shape.borderRadius};
  padding: 10px;
  display: flex;
  flex: 1;
`;

export const CheckboxField = styled.label`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 5px;
  width: 100%;
  min-height: 56px;
  padding: 12px;
  cursor: pointer;

  & > :first-child {
    flex: 0 0 auto;
    width: auto;
  }
  border-radius: ${({ theme }) => theme.shape.borderRadius};
  background-color: ${({ theme }) =>
    theme.isDarkMode
      ? lighten(theme.palette.background, 0.05)
      : theme.palette.background};
  box-shadow: inset 0px 0px 1px 1px
    ${({ theme }) =>
      theme.isDarkMode
        ? lighten(theme.palette.background, 0.05)
        : theme.palette.background};
`;

export const CheckboxLabel = styled(Typography)`
  font-size: 14px;
  font-weight: 600;
  font-family: Montserrat, sans-serif;
  color: ${({ theme }) =>
    theme.isDarkMode ? darken(theme.common.white, 0.3) : theme.common.black};
`;
